import axios from 'axios';
import * as types from '../constants/ActionTypes';
import * as notifier from '../constants/NotifierTypes';
import { chatBotContactTo } from '../constants/UtilVariables';
import { locationUpdate } from './action-contact-location';
import Page from '../../lib/page';
import { trackPage, trackSetUp } from '../../lib/analytics-helper';
import { postChatBotEligibility } from './action-postchatbot-eligibility';
import { isPUIIntentEnabled } from '../../lib/puiTopicHelper';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export const preserveFieldDataNoIntent = (formData) => ({
  type: types.PRESERVE_FIELD_DATA_NO_INTENT,
  payload: formData,
});

export const sendEmailRequestNoIntent = () => ({
  type: types.SEND_EMAIL_NO_INTENT,
});

export const receiveEmailSuccessResponseNoIntent = (options = {}) => {
  // FPTI for Email successful submission
  trackPage({ id: 'emailByPassPage', link: `smarthelp-email-submit-success|${options.topicRefId}` });
  return {
    type: types.RECEIVE_EMAIL_RESPONSE_NO_INTENT,
    payload: notifier.getEmailSentSuccess(options),
  };
};

export const receiveEmailErrorResponseNoIntent = (topicRefId) => {
  // FPTI error for Email submission
  trackSetUp({ id: 'emailByPassPage', link: `smarthelp-email-submit-error|${topicRefId}` });
  return {
    type: types.RECEIVE_EMAIL_ERROR_NO_INTENT,
    payload: notifier.functionIsUnavailable,
  };
};

export const goBackToChangeTopicTreeNoIntent = () => ({
  type: types.CANCEL_EMAIL_FORM_NO_INTENT,
});

export const goBackToCancelEmailFormNoIntent = () => ({
  type: types.CANCEL_EMAIL_FORM_NO_INTENT,
});

export const preserveDataNoIntent = (responseData) => (dispatch) => {
  dispatch(preserveFieldDataNoIntent(responseData));
};

export const sendEmailNoIntent = (options) => (dispatch) => {
  dispatch(sendEmailRequestNoIntent());
  const createMsgURL = (Page.getLogoutEmailRefId() || (isPUIIntentEnabled() && !Page.isLoggedIn())) ? '/smarthelp/guest-create-msg' : '/smarthelp/create-msg';
  const topicRefId = (options && options.emailPayload && options.emailPayload.topic_code) || '';

  axios.post(createMsgURL, options.emailPayload).then(() => {
    dispatch(receiveEmailSuccessResponseNoIntent({
      hasCommunityAccess: options.hasCommunityAccess, isSmcEnabled: options.isSmcEnabled, desc: options.thankyouPageDescription, topicRefId,
    }));
  }).catch(() => {
    dispatch(receiveEmailErrorResponseNoIntent(topicRefId));
  });
};

export const cancelEmailFormNoIntent = () => (dispatch) => {
  dispatch(goBackToCancelEmailFormNoIntent());
  // chatBot Eligibility API call
  const postChatBotResponse = Page.getChatBotEligibilityParams('contactUSpage', 'GENERIC');
  dispatch(postChatBotEligibility(postChatBotResponse));
  if (Page.getChatBotContactTo() === chatBotContactTo.email) {
    window.open('/smarthelp/contact-us', '_self');
  } else {
    dispatch(locationUpdate({ pageName: 'contactUs' }));
  }
};
